/**
 * Component to render SCA Managed board page
 */
const ChiefExecutiveOfficerPage = (): React.ReactElement => {
  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="chief-executive-officer-page-component"
    >
      <p>
        <strong>Objectives of the Award</strong>
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          The Best Chief Executive Officer Award recognises leaders who have
          successfully guided their organisations to new heights within their
          respective industry segments while demonstrating excellence in
          corporate governance.
        </li>
        <li>
          The Award aims to showcase exemplary leadership that envisions
          innovative business practices, inspires employees to exceed
          expectations, strengthens brand presence, and contributes meaningfully
          to industry development.
        </li>
        <li>
          This Award highlights CEOs who exemplify strategic foresight,
          operational excellence, and a commitment to ethical governance,
          setting benchmarks for leadership within the corporate world.
        </li>
      </ul>

      <p>
        <strong>Categories of the Award</strong>
      </p>

      <p>
        The Award will be presented for the following categories of companies:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          Companies with market capitalisation of
          <strong>S$1 billion and above</strong>
        </li>
        <li>
          Companies with market capitalisation of
          <strong>S$300 million to less than S$1 billion</strong>
        </li>
        <li>
          Companies with market capitalisation of
          <strong>less than S$300 million</strong>
        </li>
      </ul>

      <p>
        <strong>Selection and Judging Process</strong>
      </p>

      <p>The selection process involves three key stages:</p>

      <p>
        <strong>Stage 1:</strong> Identification of potential candidates through
        nominations, media reports, industry insights, company performance, and
        rankings in the ASEAN Corporate Governance Scorecard and the Singapore
        Governance and Transparency Index. A preliminary shortlist is developed
        based on these inputs.
      </p>

      <p>
        <strong>Stage 2:</strong> Further research and discreet inquiries are
        conducted on the shortlisted candidates, refining the list for final
        evaluation.
      </p>

      <p>
        <strong>Stage 3:</strong> A panel of judges reviews and evaluates the
        final shortlist, considering the comprehensive research and
        predetermined criteria developed.
      </p>

      <p>
        <strong>Criteria</strong>
      </p>

      <p>
        <strong>Governance</strong>
      </p>

      <p>
        The CEO sets a tone of excellence in corporate governance through
        personal example, upholding a strict code of business ethics across the
        organisation. High standards of governance, controls, and accountability
        are integrated into business growth and expansion strategies. A balanced
        relationship between the board and management enhances overall
        effectiveness, positioning the CEO as a true advocate of best-in-class
        board practices within the firm and the broader business community.
      </p>

      <p>
        <strong>Financial Performance</strong>
      </p>

      <p>
        Exceptional, sustainable financial performance is demonstrated through
        consistent delivery of strong financial metrics over the years. Special
        recognition is given to leadership that navigates critical situations
        including driving successful turnarounds in the challenging geopolitical
        and macro-economic environments.
      </p>

      <p>
        <strong>Strategy</strong>
      </p>

      <p>
        The CEO articulates a clear vision and builds strategic frameworks to
        anticipate crises and lead transformative change. A high-impact
        comprehensive corporate strategy is developed by integrating market
        trends, competitive analysis, and other key factors, creating a
        sustainable competitive advantage for the company.
      </p>

      <p>
        <strong>Operational Excellence</strong>
      </p>

      <p>
        Operational excellence is pursued in digitalisation, people management,
        risk management, cybersecurity, and innovation, fostering a resilient
        and high-functioning organisation. The CEO&apos;s leadership results in
        significant improvements and transformational changes, building an
        efficient, agile and robust organisation.
      </p>

      <p>
        <strong>Sustainability and Social Impact</strong>
      </p>

      <p>
        A proactive approach to sustainability and social initiatives is
        integral to the CEO&apos;s leadership. Sustainability is embedded into
        business strategy and operations, with tangible results adhering to
        reporting guidelines. Champions corporate philanthropy, volunteerism,
        and community outreach to enhance societal well-being.
      </p>
    </div>
  );
};

export default ChiefExecutiveOfficerPage;
